import React, { Component } from 'react';
import * as Common from './../helpers/Common';
import * as Config from '../config/Config';
import * as User from '../helpers/User';

const $= window.$;

class MySearch extends Component {
	constructor(props) {
		super(props);
        this.state={
            
            search_results : [],
            total : 0,
            txtSearch : '',
           
           
        };
       
      
      

	}

	handleChange(e){
		this.setState({
			[e.target.name]:e.target.value
		})
	}


	handler(type,data_sent){

	     this.props.handler(type,data_sent);

	}

	getSearchResult(key){
		let search_key = key;
		if(search_key == ""){
			$("#err_course").show();
			return false;
		}
		else{
			$("#err_course").hide();
			let learnerID = Common.getUserData("id", true);
			let productID = Common.getUserData("productID", true);
			let pinID = Common.getUserData("pinID", true);
	
			 Common.reactLoader("show", "Please wait...");
				fetch(Config.domainUrl+'resources/search-results', {
						method: 'POST',
						headers: {
						  'Accept': 'application/json',
						  'Content-Type': 'application/json',
						  'Authorization':'Bearer ' +Common.getTokenData()
						},
	
						  body: JSON.stringify({
							learnerID:learnerID,search_key:search_key,product:productID,pinid:pinID
						  })
						}).then((response) => response.json())
					   .then((responseJson) => {
					   //	alert(JSON.stringify(responseJson)) ;
						   Common.reactLoader("hide");
						   if(responseJson.status != 0){
	
							this.setState({
								search_results :responseJson.search_results,
								txtSearch : search_key,
								total : responseJson.total
							});
						   }
	
	
					});
		}
	}

	
	componentDidMount() {
		$("#err_course").hide();
        const {searchkey} = this.props;
        this.getSearchResult(searchkey);
    }

    _handleKeyPress(e) {
    	
		if (e.key === "Enter") {
			this.getSearchResult(this.state.txtSearch);
		}
	}
	




		render() {

			//let results = "";
			
			let results = this.state.search_results.map((result,k)=>{
				if(result.subject_id != null && result.content != ""){

					return(
							<ul key={result.subject_id} className="sub">
								<li>
									<a href="javascript:void(0);" onClick={e=>this.handler('getback',result.sent_id)} className="txt-slnk">{result.subject} </a><br/>
									<a href="javascript:void(0);" onClick={e=>this.handler('getback',result.sent_id)} >{result.chapter_name}  </a><br/>
									<span dangerouslySetInnerHTML={{__html: result.content}}/><br/>
								</li>
							</ul>
						)
				}
			});

			(this.state.total > 0)?results=results:results='No results found.';

			
			
			return (
				<div className="main-inner">
					<div className="border-box">
						<div className="title-box-gray">
							<div className="search-right">
	 								<input type="text" id="txtSearch"  name="txtSearch" value={this.state.txtSearch} onChange={(e)=>this.handleChange(e)} onKeyPress={(e)=>this._handleKeyPress(e)}/>
	 								<input type="button" value="Search" id="sebut" onClick={(e)=>this.getSearchResult(this.state.txtSearch)} />
									<p className="error" id="err_course">Search key cannot be empty</p>
	 						</div>
	 					Search results</div>
	                    <section id="semana-scroll-inner" className="scrollbar">
	                        <section className="viewport">
	                            <section className="overview">
	                                <div className="inner-content" style={{position:'relative'}}>	
	                                	<h2 className="rul-title">About {this.state.total} results</h2>
		                                <div style={{position: 'absolute', top: '10px', right: '20px'}}><a  href="javascript:void(0);" onClick={e=>this.handler('getback')}><img src={process.env.PUBLIC_URL+"/images/back-icon.png"} align="absmiddle" alt="Courseware Home" title="Courseware Home" /> Courseware</a>
		                                </div>	
		                                {results}
									</div>
								</section>
		                    </section>
	                    </section>
					</div>                  			
                </div>
			);
		}
}

export default MySearch;



// WEBPACK FOOTER //
// ./src/learning_resources/MySearch.js